import { Box } from '@mui/material'
import { Whiteboard20Regular } from '@/components/Icon'
import SectionCard from './SectionCard'
import SectionTitleRow from './SectionTitleRow'
import styles from './BoardsSection.module.scss'
import { BoardsSectionList } from './BoardsSectionList.jsx'
import { BoardsSectionResizeHandle } from './BoardsSectionResizeHandle.jsx'

export default function BoardsSectionView(props) {
  const { title, resize, pinnedThreads, showAll, boards, selectedThreadId, onBoardClick, onSelectThread, onThreadMenuAction, onRenameThread } = props

  return (
    <SectionCard className={styles.boardsCard} sx={{ height: resize.boardsHeightPx }}>
      <Box className={styles.inner}>
        <SectionTitleRow Icon={Whiteboard20Regular} title={title} />
        <BoardsSectionList
          showAll={showAll}
          boards={boards}
          pinnedThreads={pinnedThreads}
          selectedThreadId={selectedThreadId}
          onBoardClick={onBoardClick}
          onSelectThread={onSelectThread}
          onThreadMenuAction={onThreadMenuAction}
          onRenameThread={onRenameThread}
        />
      </Box>
      <BoardsSectionResizeHandle resize={resize} />
    </SectionCard>
  )
}
